// const BASE_URL = "http://localhost:3004/api/";
const BASE_URL = "https://v2.mindpulse.com.au/api/";

export const LOGIN_USER = BASE_URL + "user/login";
export const GET_USER_PROFILE = BASE_URL + "user/profile";
export const UPLOAD_PROFILE_PICTURE = BASE_URL + "user/avatar/update";
export const UPDATE_USER_PROFILE = BASE_URL + "user/profile/update";

// Notifications
export const GET_PRIORITY_NOTIFICATIONS =
  BASE_URL + "notifications/priority/get";
export const GET_RECENT_NOTIFICATIONS = BASE_URL + "notifications/recent/get";
export const MARK_NOTIFICATIONS_READ = BASE_URL + "notifications/actions/read";
export const DELETE_NOTIFICATIONS = BASE_URL + "notifications/actions/delete";

// Page Titles
export const GET_PAGE_TITLE = BASE_URL + "page/title/get/";

// Recipes
export const GET_RECIPE = BASE_URL + "recipe/get/";
export const GET_RECIPES = BASE_URL + "recipes/get";
export const GET_CATEGORY_RECIPES = BASE_URL + "recipes/category/get/";

// Mood Capture Calendar
export const GET_MOOD_CAPTURE_CALENDAR = BASE_URL + "mood/calendar";
export const GET_PEOPLE_CALENDAR_METRICS = BASE_URL + "mood/people/calendar";
export const GET_PERSON_CALENDAR_DATA =
  BASE_URL + "mood/people/calendar/person";

// Exercises
export const GET_EXERCISES = BASE_URL + "exercises/get";
export const GET_CATEGORY_EXERCISES = BASE_URL + "exercises/get/category/";

// Mindfulness
export const GET_MINDFULNESS = BASE_URL + "mindfulness/get";

// Virtual Commutes
export const GET_VIRTUAL_COMMUTES = BASE_URL + "virtual_commutes/get";

// EAP
export const GET_EAP_ITEMS = BASE_URL + "eap/get";

// Notify Manager
export const SUBMIT_SUPPORT_REQUEST = BASE_URL + "user/support/request";

// Mood Capture
export const SUBMIT_MOOD_CAPTURE = BASE_URL + "mood/capture";
export const UNDO_MOOD_CAPTURE = BASE_URL + "mood/capture/undo";

// Questionnaires
export const GET_QUESTIONNAIRES = BASE_URL + "questionnaires/get";
export const GET_NEXT_QUESTION = BASE_URL + "questionnaires/next/";
export const GET_QUESTIONNAIRE_DETAILS = BASE_URL + "questionnaires/details/";
export const GET_ORG_QUESTIONNAIRE_DETAILS =
  BASE_URL + "questionnaires/organisation/details/";
export const SUBMIT_QUESTIONNAIRE_ANSWER =
  BASE_URL + "questionnaires/answer/submit";

// Superadmin Endpoints
export const GET_ORGANISATION_MOOD_DATA =
  BASE_URL + "mood/people/calendar/organisation";
export const GET_ORGANISATION_MOOD_DATA_CSV =
  BASE_URL + "mood/people/calendar/organisation/export";

export const UPLOAD_COMPANY_LOGO = BASE_URL + "company/logo/upload";
export const GET_COMPANY_PEOPLE = BASE_URL + "company/people/get";
export const GET_COMPANY_DETAILS = BASE_URL + "company/details/get";
export const UPDATE_COMPANY_DETAILS = BASE_URL + "company/details/update";
export const GET_PEOPLE_CALENDAR_PROFILES =
  BASE_URL + "mood/people/calendar/profiles";

// Organisation Questionniares
export const GET_ORGANISATION_QUESTIONNAIRES =
  BASE_URL + "organisation/questionnaires/get";
export const GET_QUESTIONNAIRE_RESPONSES =
  BASE_URL + "organisation/questionnaires/answers/get/";
export const DELETE_ORGANISATION_QUESTIONNAIRE =
  BASE_URL + "organisation/questionnaires/delete";
export const DOWNLOAD_QUESTIONNAIRE_CSV =
  BASE_URL + "organisation/questionnaires/answers/download";

// Questionnaire Management
export const CREATE_QUESTIONNIARE =
  BASE_URL + "organisation/questionnaires/create";

// Organisation User Settings
export const TOGGLE_SCHOOL_MODE =
  BASE_URL + "organisation/user/schoolmode/toggle";
export const TOGGLE_PAUSE_ACCESS = BASE_URL + "organisation/user/access/toggle";
export const CREATE_USER = BASE_URL + "organisation/user/create";
export const DELETE_USER = BASE_URL + "organisation/user/delete";
export const UPDATE_USER_PASSWORD =
  BASE_URL + "organisation/user/password/reset";

// Support People
export const ADD_SUPPORT_PERSON = BASE_URL + "support/people/add";
export const DELETE_SUPPORT_PERSON = BASE_URL + "support/people/delete";

// Manager Team
export const GET_MANAGERS_TEAM = BASE_URL + "manager/team/get";
export const REMOVE_TEAM_MEMBER = BASE_URL + "manager/team/person/delete";
